declare global {
	interface Window {
		dataLayer:any;
	}
}

function trackFAQ(faqText, eventType) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'clickText' : faqText, //Insert the text of the FAQ
		'event' : eventType
	});
}


function Accordion() {
	$('.js-acc-trigger').on('click', function(e){
		let $this = $(this),
			$parent = $this.parent('.accordion-list__item'),
			textContent = $this.text();

		$parent.toggleClass('state-open');
		e.preventDefault();

		if($this.parents('.state-open').length) {
			trackFAQ(textContent, 'faq_expanded');
		} else {
			trackFAQ(textContent, 'faq_collapsed');
		}
	});
}

export function init() {
	Accordion();
	$(document).ready(function(){
		let items = document.querySelectorAll('.accordion-list--faq .accordion-list__item');

		if(document.querySelector('.accordion-list--faq')) {
			let el = document.createElement('script');
			el.type = 'application/ld+json';
			let jsonString;
			let questions = [];


			items.forEach((item) => {
				let qstn = item.querySelector('.js-acc-trigger');
				let qstnCon:any = qstn.textContent;
				let content = item.querySelector('.accordion-list__content-inner');
				let contentCon:any = content.innerHTML;
				let theQuestion = {
					"@type": "Question",
					"name": qstnCon.replace(/(\r\t\n|\n|\r|\t)/gm, ""),
					"acceptedAnswer": {
						"@type": "Answer",
						"text": contentCon.replace(/(\r\t\n|\n|\r|\t)/gm, "")
					}
				}
				questions.push(theQuestion);
			});

			jsonString = {
				"@context": "https://schema.org",
				"@type": "FAQPage",
				"mainEntity": questions
			}

			el.text = JSON.stringify(jsonString);

			document.querySelector('head').appendChild(el);
		}
	});
}
